module.exports = __webpack_public_path__ + "img/jackrabbit-logo.620e2413.png";